import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import PeopleSteps from 'app/components/People/PeopleSteps';
import usePeopleContent from 'app/components/People/hooks/usePeopleContent';
import usePeopleResetSearch from 'app/components/People/usePeopleResetSearch';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';
import { PEOPLE_CONTEXT, setContext } from 'store/reducers/people/people-reducer';

const PeopleContact = lazy(() => import('app/components/People/PeopleContact'));
export default function BD100Teaming() {
  const dispatch = useDispatch();
  usePeopleContent({ context: PEOPLE_CONTEXT.TEAMING });
  const peopleResetSearch = usePeopleResetSearch();

  useEffect(() => {
    dispatch(setContext(PEOPLE_CONTEXT.TEAMING));
    const prompt = new URLSearchParams(window.location.search).get('prompt');
    peopleResetSearch();
    if (prompt) {
      dispatch(setPrompt(prompt));
    }
  }, []);

  return (
    <>
      <PeopleSteps />
      <Suspense fallback={<></>}>
        <PeopleContact />
      </Suspense>
    </>
  );
}
